// UIButton.tsx

import React from 'react'
import { Icon } from '../Icon'

interface UIButtonProps {
  label?: string
  onClick?: () => void
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button'
  secondary?: boolean
  loading?: boolean
  iconName?: string
  iconColor?: string
}

const UIButton: React.FC<UIButtonProps> = ({
  label,
  onClick,
  disabled = false,
  type,
  secondary = false,
  loading,
  iconName,
  iconColor,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`w-full h-full px-[20px] py-[12px] rounded-[72px] gap-2 ${
        disabled
          ? 'bg-gray1 text-text7 cursor-not-allowed'
          : secondary
            ? 'bg-gray2 text-text1 hover:text-text2'
            : 'bg-bluishGreen text-text8 hover:text-text7'
      } font-semibold text-sm flex items-center justify-center focus:outline-none`}
      onClick={onClick}
    >
      {iconName && (
        <Icon
          name={iconName}
          strokeWidth={1.2}
          stroke={iconColor ? iconColor : '#02698C'}
          width={14}
          height={14}
        />
      )}
      {label}
      {loading && (
        <div className="flex justify-center items-center">
          <div
            className={`animate-spin rounded-full border-t-2 border-b-2 border-white w-4 h-4`}
          ></div>
        </div>
      )}
    </button>
  )
}

export default UIButton
